import PropTypes from "prop-types";
import React from "react";
import {Menu as MenuIcon} from "react-feather";
import {Link as RouterLink} from "react-router-dom";

import clsx from "clsx";

import {
  AppBar,
  Box,
  Divider,
  Hidden,
  IconButton,
  SvgIcon,
  Toolbar,
  makeStyles
} from "@material-ui/core";
import Logo from "src/components/Logo";

import Account from "./Account";
import LangSwitching from "./LangSwitching";
import Notifications from "./Notifications";
import PlatformSelect from "./Platform";
import Settings from "./Settings";
import {THEMES} from "src/constants";

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    ...(theme.name === THEMES.LIGHT
      ? {
          boxShadow: "none",
          backgroundColor: theme.palette.primary.main
        }
      : {}),
    ...(theme.name === THEMES.ONE_DARK
      ? {
          backgroundColor: theme.palette.background.default
        }
      : {})
  },
  toolbar: {
    minHeight: 64
  },
  langStartIcon: {
    color: theme.palette.background.default
  },
  langEndIcon: {
    color: theme.palette.background.default
  },
  langPrimaButton: {
    color: theme.palette.background.default
  }
}));

function TopBar({className, onMobileNavOpen, ...rest}) {
  const classes = useStyles();

  return (
    <AppBar className={clsx(classes.root, className)} {...rest}>
      <Toolbar className={classes.toolbar}>
        <Hidden lgUp>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            onClick={onMobileNavOpen}
          >
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        </Hidden>
        <Hidden mdDown>
          <RouterLink to="/">
            <Logo />
          </RouterLink>
        </Hidden>
        <PlatformSelect />
        <Box ml={2} flexGrow={1} />
        {/* <AuditLogSelect /> */}
        {/* <Content /> */}
        {/* <MasterData /> */}

        {/* <Search /> */}
        {/* <Contacts /> */}
        <LangSwitching
          themes={{
            startIcon: classes.langStartIcon,
            endIcon: classes.langEndIcon,
            primaButton: classes.langPrimaButton
          }}
        />
        <Notifications />
        <Settings />
        <Divider
          orientation="vertical"
          style={{margin: "15px 0px", backgroundColor: "white", opacity: 0.5}}
          flexItem
        />
        <Box ml={2}>
          <Account />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

export default TopBar;
